// This will be overwritten with $GIT_COMMIT at build time by /script/assets
export default '';